import React, { useState, useEffect } from "react";
import { Select, Container, Grid, TextField, MenuItem, FormControl, InputLabel, Checkbox, FormControlLabel } from '@mui/material';

const EditUser = ({ onSubmit, userData }) => {
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [externalId, setExternalId] = useState('');
    const [roles, setRoles] = useState(1);

    useEffect(() => {
        if (userData) {
            setFirstName(userData.firstName || '');
            setLastName(userData.lastName || '');
            setEmail(userData.email || '');
            setExternalId(userData.externalId || '');
            setRoles(roleLabels[userData.roles?.[0]] ?? 1);
        }
    }, [userData]);

    const roleLabels = {
        "Admin": 0,
        "User": 1,
        "Manager": 2,
        "NoAccess": 3,
        "IdUser": 4
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Collect all form data
        const formData = {
            firstName,
            lastName,
            email,
            externalId,
            roles
            // Collect other fields as needed
        };
        // Call onSubmit function passed as a prop
        onSubmit(formData);
    }


    return (
        <form id='create-form' onSubmit={handleSubmit}>
            <Container maxWidth="md" sx={{ marginTop: "10px" }}>
                <h4>User Information</h4>
                <Grid container spacing={3}>
                    {/* First Name */}
                    <Grid item xs={12} sm={6}>
                        <TextField fullWidth label="First Name" required
                            value={firstName}
                            onChange={(e) => setFirstName(e.target.value)} />
                    </Grid>

                    {/* Last Name */}
                    <Grid item xs={12} sm={6}>
                        <TextField fullWidth label="Last Name" required
                            value={lastName}
                            onChange={(e) => setLastName(e.target.value)} />
                    </Grid>

                    {/* Email */}
                    <Grid item xs={12} sm={6}>
                        <TextField fullWidth label="Email" required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)} />
                    </Grid>

                    {/* External Id */}
                    <Grid item xs={12} sm={6}>
                        <TextField fullWidth label="External Id"
                            value={externalId}
                            onChange={(e) => setExternalId(e.target.value)} />
                    </Grid>

                    {/* Role */}
                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth variant="outlined" >
                            <InputLabel>Role</InputLabel>
                            <Select
                                label="Role"
                                value={roles}
                                onChange={(e) => setRoles(e.target.value)}
                            >
                                <MenuItem value={0}>Admin</MenuItem>
                                <MenuItem value={1}>User</MenuItem>
                                <MenuItem value={2}>Manager</MenuItem>
                                <MenuItem value={3}>No Access</MenuItem>
                                <MenuItem value={4}>ID User</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
            </Container >
        </form>
    )
}

export default EditUser;